import { render, staticRenderFns } from "./sign-up-view.vue?vue&type=template&id=c44cfd04&scoped=true&"
import script from "./sign-up-view.vue?vue&type=script&lang=ts&"
export * from "./sign-up-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44cfd04",
  null
  
)

export default component.exports